import { push as updatePath } from 'react-router-redux';
import { change, initialize } from 'redux-form';
import { createFormAction } from 'redux-form-saga';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { ga } from 'helpers/multitrack';
import * as ObjectUtil from 'helpers/object';
import { setActiveOfferId } from 'helpers/pathToPurchaseHelper';
import { segment } from 'helpers/segment';
import { setSelectedOffer, setSubmittedOfferProductId, setSubmittedOfferUrl } from 'redux/modules/offer';

export const PRODUCT_FORM = 'signup-card-product';
export const productFormAction = createFormAction(PRODUCT_FORM);

export const initializeProductForm = hiddenFields => ({
  type: `INITIALIZE_${PRODUCT_FORM}`,
  hiddenFields,
});

export const updateSelectedOffer = offer => ({
  type: `UPDATE_${PRODUCT_FORM}_SELECTED`,
  offer,
});

export const updateSubmittedOffer = offer => ({
  type: `UPDATE_${PRODUCT_FORM}_SUBMITTED`,
  offer,
});

export function* doInitializeProductForm(client, { hiddenFields }) {
  yield put(initialize(PRODUCT_FORM, ObjectUtil.pick(['productId', 'productType', 'resumeSignupLink'], hiddenFields)));
}

export function* doUpdateSelectedOffer(client, { offer }) {
  yield put(setSelectedOffer(offer));
}

export function* doUpdateSubmittedOffer(client, { offer }) {
  yield all([
    put(change(PRODUCT_FORM, 'productId', offer.productId)),
    put(change(PRODUCT_FORM, 'resumeSignupLink', offer.url)),
  ]);
}

export function* doSubmitProductForm(client, { payload: form }) {
  yield all([
    call(setActiveOfferId, form.productId),
    put(setSubmittedOfferProductId(form.productId)),
    put(setSubmittedOfferUrl(form.resumeSignupLink)),
  ]);
  if (form.resumeSignupLink && (yield select(isLoggedIn))) {
    yield put(updatePath(form.resumeSignupLink));
  } else {
    yield call(segment.track, 'Membership Purchase', {
      action: 'Membership Purchase Product Selection',
    });
    yield call(ga, 'Membership Purchase', 'Membership Purchase Product Selection');

    return yield put(productFormAction.success(ObjectUtil.pick(['productId', 'productType'], form)));
  }
}

export function* watchProductFormSagas(client) {
  yield takeEvery(initializeProductForm().type, doInitializeProductForm, client);
  yield takeEvery(updateSelectedOffer().type, doUpdateSelectedOffer, client);
  yield takeEvery(updateSubmittedOffer().type, doUpdateSubmittedOffer, client);
  yield takeEvery(productFormAction.REQUEST, doSubmitProductForm, client);
}
